<!-- 转岗业务信息 -->
<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="top"
             :model="dataForm"
             ref="dataForm">
      <!-- 基本信息 -->
      <div class="opten-title"><em class="el-icon-caret-right"></em>{{ $t('user.essentialInformation') }}</div>
      <el-row>
        <el-col :span="6">
          <!-- 证件类型 -->
          <el-form-item :label="$t('user.idtype')"
                        prop="idType">
            <el-select v-model="dataForm.idType"
                       placeholder=""
                       :disabled="true">
              <el-option v-for="(item,index) in idTypeList"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 身份证护照 -->
          <el-form-item :label="$t('user.passportIdcard')"
                        prop="jobStatus">
            <el-input v-model="dataForm.idcard"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 出生日期 -->
          <el-form-item :label="$t('user.dateofbirth')"
                        prop="birthday">
            <el-date-picker v-model="dataForm.birthday"
                            type="date"
                            :disabled="true"
                            placeholder=""
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('user.gender')"
                        prop="sexCode">
            <el-select v-model="dataForm.sexCode"
                       filterable
                       :disabled="true"
                       placeholder="">
              <el-option v-for="(item,index) in sexCode"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <!-- 姓 -->
          <el-form-item :label="$t('user.firstname')"
                        prop="address">
            <el-input v-model="dataForm.lastName"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 名 -->
          <el-form-item :label="$t('user.lastname')"
                        prop="zipCode">
            <el-input v-model="dataForm.firstName"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 姓名 -->
          <el-form-item :label="$t('user.name')"
                        prop="bmwJoinDate">
            <el-input v-model="dataForm.userName"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 学历 -->
          <el-form-item :label="$t('user.education')"
                        prop="educationCode">
            <el-select v-model="dataForm.educationCode"
                       filterable
                       :disabled="true"
                       placeholder="">
              <el-option v-for="(item,index) in educationCode"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 账号信息 -->
      <div class="opten-title"><em class="el-icon-caret-right"></em>{{ $t('user.accountinformation') }}</div>
      <el-row>
        <el-col :span="6">
          <div class="img-div">
            <img alt="" :src="dataForm.headurl" />
          </div>
        </el-col>
        <el-col :span="18">
          <el-row class="row-mar-l">
            <el-col :span="8">
              <!-- 用户id -->
              <el-form-item :label="$t('user.userID')"
                            prop="userId">
                <el-input v-model="dataForm.userCode"
                          :disabled="true"
                          placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 员工号 -->
              <el-form-item :label="$t('user.userCardNo')"
                            prop="userCardNo">
                <el-input v-model="dataForm.userCardNo"
                          :placeholder="$t('organization.orgCodeMessage')"
                          :disabled="true"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <!-- 同意收集隐私 -->
              <el-form-item :label="$t('user.agreeconceal')"
                            prop="agreePolicy">
                <el-select v-model="dataForm.agreePolicy"
                           filterable
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in agreePolicy"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="row-mar-l">
            <el-col :span="8">
              <!-- 组织类型 -->
              <el-form-item :label="$t('organization.orgType')"
                            prop="orgType">
                <el-select v-model="dataForm.orgType"
                           filterable
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in orgTypeArr"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- 权限分类 -->
              <el-form-item :label="$t('user.permissionclassification')"
                            prop="idcard">
                <el-select v-model="dataForm.authType"
                           filterable
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in perClassification"
                             :key="index"
                             :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 手机 -->
            <el-col :span="8">
              <el-form-item :label="$t('user.mobile')"
                            prop="mobile">
                <el-input v-model="dataForm.mobile"
                          :disabled="true"
                          placeholder=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="row-mar-l">
        <el-col :span="6">
          <!-- 最后登录时间 -->
          <el-form-item :label="$t('user.lastlogintime')"
                        prop="mobile">
            <el-input v-model="dataForm.lastLoginTime"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 最后修改密码时间 -->
          <el-form-item :label="$t('user.lastPassword')">
            <el-input v-model="dataForm.passwordUpdateTime"
                      :placeholder="$t('user.null')"
                      :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 是否允许登录 -->
          <el-form-item :label="$t('user.status10')"
                        prop="loginFlag">
            <el-select v-model="dataForm.loginFlag"
                       clearable
                       :disabled="true"
                       :placeholder="$t('user.select')">
              <el-option v-for="(item,index) in leafFlag"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 邮箱 -->
          <el-form-item :label="$t('user.userEmail')"
                        prop="email">
            <el-input v-model="dataForm.email"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row-mar-l">
        <!-- 紧急联系人及联系方式 -->
        <el-col :span="6">
          <el-form-item :label="$t('user.emergencyContact')"
                        prop="emergencyContactInfo">
            <el-input v-model="dataForm.emergencyContactInfo"
                      placeholder=""
                      :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <!-- 隐私协议 -->
        <!-- <el-col :span="12"
                style="text-align: center">
          <el-form-item :label="$t('user.privacyFileUrl')"
                        prop="privacyFileUrl"
                        style="width:90% !important">
            <div class="inline"
                 v-if="privacyFileUrl && privacyFileUrl !== ''">
              <a target="_blank"
                 :href='privacyFileUrl'
                 style="margin: 5px">用户隐私协议</a>
            </div>
            <div v-else
                 style="padding-top: 5px">暂无隐私协议</div>
          </el-form-item>
        </el-col> -->
      </el-row>
      <!-- 业务信息 -->
      <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.business')}}</div>
      <el-row>
        <el-col :span="6">
          <!-- 服务宝马开始时间 -->
          <el-form-item :label="$t('organization.joinDateBmw')"
                        prop="value">
            <el-date-picker v-model="dataForm.bmwJoinDate"
                            type="date"
                            :disabled="true"
                            placeholder=""
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 在职状态 -->
          <el-form-item :label="$t('user.incumbency')"
                        prop="leaveDate">
            <el-select placeholder=""
                       v-model="dataForm.jobStatus"
                       :disabled="true">
              <el-option v-for="(item,index) in jobStatus"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 加入当前公司时间 -->
          <el-form-item :label="$t('user.accessionDate')"
                        prop="jobCode">
            <el-date-picker v-model="dataForm.orgJoinDate"
                            type="date"
                            :disabled="true"
                            placeholder=""
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <!-- 离职日期 -->
          <el-form-item :label="$t('user.leaveDate')"
                        prop="value">
            <el-date-picker v-model="dataForm.leaveDate"
                            type="date"
                            :disabled="true"
                            placeholder=""
                            value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <!-- 宝龄 -->
          <el-form-item :label="$t('user.BMWtime')"
                        prop="networkJoinDate">
            <el-input v-model="dataForm.bmwSeniority"
                      :disabled="true"
                      placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"
                style="text-align:center">
          <!-- 角色 -->
          <el-form-item class="role-div"
                        :label="$t('user.role')"
                        prop="roleName"
                        style="width:90% !important">
            <el-input type="textarea"
                      autosize
                      placeholder=""
                      v-model="roleIds"
                      :disabled="true">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 宝马集团 -->
      <div v-if="dataForm.orgType === '10'">
        <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.GWMinformation')}}</div>
        <el-row>
          <el-col :span="6">
            <!-- 所属公司 -->
            <el-form-item :label="$t('user.GWMcompany')">
              <!-- 公司 -->
              <el-select placeholder=""
                         v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="(item,index) in companyResults"
                           :key="index"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 部门 -->
            <el-form-item :label="$t('user.department')"
                          prop="trialEndDate">
              <el-input v-model="dataForm.bmwDeptCode"
                        :disabled="true"
                        placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 宝马集团职位 -->
            <el-form-item :label="$t('user.position')">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top">
                <div slot="content"
                     v-html="jobCodeContent"></div>
                <el-select v-model="dataForm.jobCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in positionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 合作伙伴/合作院校/经销商集团 -->
      <div v-if="dataForm.orgType === '20' || dataForm.orgType === '30'">
        <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('organization.orgType2030')}}</div>
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('user.GWMcompany')"
                          prop="trialEndDate">
              <!-- 所属公司 -->
              <el-select placeholder=""
                         v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="(item,index) in companyResults"
                           :key="index"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 合作伙伴职位 -->
            <el-form-item :label="$t('user.position')">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top">
                <div slot="content"
                     v-html="jobCodeContent"></div>
                <el-select v-model="dataForm.jobCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in positionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- BEST学员信息 -->
        <el-row class="row-mar-l"
                v-if="dataForm.authType === '50' && false">
          <el-col :span="6">
            <!-- 预签约经销商 -->
            <el-form-item :label="$t('user.reservedDistributor')"
                          prop="dealerShipId">
              <el-select v-model="dataForm.dealerShipId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="(item,index) in orgResulets"
                           :key="index"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 是否正式账号 -->
            <el-form-item :label="$t('user.numberbankaccount')"
                          prop="officialAccountFlag">
              <el-select v-model="dataForm.officialAccountFlag"
                         :disabled="true"
                         placeholder="">
                <el-option v-for="(item,index) in regulArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 在校状态 -->
            <el-form-item :label="$t('user.graduation')"
                          prop="graduateStatus">
              <el-select v-model="dataForm.graduateStatus"
                         :disabled="true"
                         placeholder="">
                <el-option v-for="(item,index) in graduationStatus"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  v-if="dataForm.graduateStatus === '10'">
            <!-- 入校时间 -->
            <el-form-item :label="$t('user.joinschool')"
                          prop="enterSchoolDate">
              <el-date-picker v-model="dataForm.enterSchoolDate"
                              type="date"
                              :placeholder="$t('user.checkdate')"
                              value-format="yyyy-MM-dd"
                              :disabled="true">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  v-if="dataForm.graduateStatus === '20' || dataForm.graduateStatus === '30'">
            <!-- 离校时间 -->
            <el-form-item :label="$t('user.leaveschool')"
                          prop="leaveSchoolDate">
              <el-date-picker v-model="dataForm.leaveSchoolDate"
                              type="date"
                              :placeholder="$t('user.checkdate')"
                              value-format="yyyy-MM-dd"
                              :disabled="true">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 经销商集团 -->
      <div v-if="dataForm.orgType === '40'">
        <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.dealerGroupInformation')}}</div>
        <el-row>
          <el-col :span="6">
            <!-- 所属公司 -->
            <el-form-item :label="$t('user.GWMcompany')">
              <!-- 公司 -->
              <el-select placeholder=""
                         v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="(item,index) in companyResults"
                           :key="index"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 经销商集团职位 -->
            <el-form-item :label="$t('user.position')">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top">
                <div slot="content"
                     v-html="jobCodeContent"></div>
                <el-select v-model="dataForm.jobCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in positionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 经销商网点 -->
      <div v-if="dataForm.orgType === '60'">
        <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.dealer')}}</div>
        <el-row>
          <el-col :span="6">
            <!-- 所属经销商网点 -->
            <el-form-item :label="$t('user.outlet')"
                          prop="orgId">
              <el-select placeholder=""
                         v-model="dataForm.orgId"
                         :disabled="true">
                <el-option v-for="item in results"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 所属品牌 -->
            <el-form-item :label="$t('user.brandCodes')"
                          prop="">
              <el-input v-model="dataForm.brandCode"
                        :disabled="true"
                        placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 所属NSC No -->
            <el-form-item :label="$t('user.nscno')"
                          prop="">
              <el-input v-model="dataForm.nscNo"
                        :disabled="true"
                        placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 所属BBA No -->
            <el-form-item :label="$t('user.bbaNo')"
                          prop="">
              <el-input v-model="dataForm.bbaNo"
                        :disabled="true"
                        placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <el-col :span="6">
            <!-- 网点类型 -->
            <el-form-item :label="$t('user.outletType')"
                          prop="">
              <el-input v-model="dataForm.outletType"
                        placeholder=""
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 当前岗龄 -->
            <el-form-item :label="$t('user.jobyear')"
                          prop="loginFlag">
              <el-input v-model="dataForm.jobcodeAge"
                        placeholder=""
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-form label-position="top"
             :model="transferForm"
             ref="transferForm">
      <el-row>
        <el-col :span="12">
          <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.transferBefore')}}</div>
        </el-col>
        <el-col :span="12">
          <div class="opten-title"><em class="el-icon-caret-right"></em>{{$t('user.transferAfter')}}</div>
        </el-col>
      </el-row>
      <div v-if="dataForm.orgType !== '60'">
        <el-row>
          <el-col :span="6">
            <!-- 转岗前主要职位 -->
            <el-form-item :label="$t('user.position')"
                          prop="positionOriginalCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="!transferForm.positionOriginalCode || transferForm.positionOriginalCode === ''">
                <div slot="content"
                     v-html="jobCodeContent"></div>
                <el-select v-model="transferForm.positionOriginalCode"
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in positionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  :offset="6">
            <!-- 转岗后主要职位 -->
            <el-form-item :label="$t('user.position')"
                          prop="positionDestinationCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.positionDestinationCode === '' || !transferForm.positionDestinationCode">
                <div slot="content">{{transferJobCodeNum}}<br />{{transferJobCodeContent}}</div>
                <el-select v-model="transferForm.positionDestinationCode"
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in transferPositionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="dataForm.orgType === '60'">
        <el-row>
          <el-col :span="6">
            <!-- 所属经销商网点 -->
            <el-form-item :label="$t('user.outlet')"
                          prop="positionOriginalNetworkId">
              <el-select placeholder=""
                         v-model="transferForm.positionOriginalNetworkId"
                         :disabled="true">
                <el-option v-for="item in resultsOld"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 主要职位 -->
            <el-form-item :label="$t('user.position')"
                          prop="positionOriginalCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="!transferForm.positionOriginalCode || transferForm.positionOriginalCode === ''">
                <div slot="content"
                     v-html="jobCodeContent"></div>
                <el-select v-model="transferForm.positionOriginalCode"
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in positionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <!-- 转岗后 -->
          <el-col :span="6">
            <!-- 所属经销商网点 -->
            <el-form-item :label="$t('user.outlet')"
                          prop="positionDestinationNetworkId">
              <el-select placeholder=""
                         v-model="transferForm.positionDestinationNetworkId"
                         :disabled="true">
                <el-option v-for="item in resultsNew"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 职位 -->
            <el-form-item :label="$t('user.position')"
                          prop="positionDestinationCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.positionDestinationCode === '' || !transferForm.positionDestinationCode">
                <div slot="content">{{transferJobCodeNum}}<br />{{transferJobCodeContent}}</div>
                <el-select v-model="transferForm.positionDestinationCode"
                           :disabled="true"
                           placeholder="">
                  <el-option v-for="(item,index) in transferPositionlist"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <!-- 兼职1所属网点 -->
            <el-form-item :label="$t('user.outlet1')"
                          prop="partTimeOneNetworkOriginalId">
              <el-select v-model="transferForm.partTimeOneNetworkOriginalId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults0"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位1 -->
            <el-form-item :label="$t('user.parttimejob1')"
                          prop="partTimeOneOriginalCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeOneOriginalCode === '' || !transferForm.partTimeOneOriginalCode">
                <div slot="content"
                     v-html="jobCodeContentOne"></div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeOneOriginalCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList0"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <!-- 转岗后 -->
          <el-col :span="6">
            <!-- 兼职1所属网点 -->
            <el-form-item :label="$t('user.outlet1')"
                          prop="partTimeOneNetworkDestinationId">
              <el-select v-model="transferForm.partTimeOneNetworkDestinationId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in transferPartResults0"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位1 -->
            <el-form-item :label="$t('user.parttimejob1')"
                          prop="partTimeOneDestinationCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeOneDestinationCode === '' || !transferForm.partTimeOneDestinationCode">
                <div slot="content">{{transferJobCodeNumOne}}<br />{{transferJobCodeContentOne}}</div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeOneDestinationCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in transferParttimejobList0"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 兼职2所属网点 -->
            <el-form-item :label="$t('user.outlet2')"
                          prop="partTimeTwoNetworkOriginalId">
              <el-select v-model="transferForm.partTimeTwoNetworkOriginalId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults1"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位2 -->
            <el-form-item :label="$t('user.parttimejob2')"
                          prop="partTimeTwoOrignialCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeTwoOrignialCode === '' || !transferForm.partTimeTwoOrignialCode">
                <div slot="content"
                     v-html="jobCodeContentTwo"></div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeTwoOrignialCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList1"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <!-- 转岗后 -->
          <el-col :span="6">
            <!-- 兼职2所属网点 -->
            <el-form-item :label="$t('user.outlet2')"
                          prop="partTimeTwoNetworkDestinationId">
              <el-select v-model="transferForm.partTimeTwoNetworkDestinationId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in transferPartResults1"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位2 -->
            <el-form-item :label="$t('user.parttimejob2')"
                          prop="partTimeTwoDestinationCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeTwoDestinationCode === '' || !transferForm.partTimeTwoDestinationCode">
                <div slot="content">{{transferJobCodeNumTwo}}<br />{{transferJobCodeContentTwo}}</div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeTwoDestinationCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in transferParttimejobList1"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 兼职3所属网点 -->
            <el-form-item :label="$t('user.outlet3')"
                          prop="partTimeThreeNetworkOriginalId">
              <el-select v-model="transferForm.partTimeThreeNetworkOriginalId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults2"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位3 -->
            <el-form-item :label="$t('user.parttimejob3')"
                          prop="partTimeThreeOriginalCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeThreeOriginalCode === '' || !transferForm.partTimeThreeOriginalCode">
                <div slot="content"
                     v-html="jobCodeContentThree"></div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeThreeOriginalCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList2"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <!-- 转岗后 -->
          <el-col :span="6">
            <!-- 兼职3所属网点 -->
            <el-form-item :label="$t('user.outlet3')"
                          prop="partTimeThreeNetworkDestinationId">
              <el-select v-model="transferForm.partTimeThreeNetworkDestinationId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in transferPartResults2"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位3 -->
            <el-form-item :label="$t('user.parttimejob3')"
                          prop="partTimeThreeDestinationCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeThreeDestinationCode === '' || !transferForm.partTimeThreeDestinationCode">
                <div slot="content">{{transferJobCodeNumThree}}<br />{{transferJobCodeContentThree}}</div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeThreeDestinationCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in transferParttimejobList2"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 兼职4所属网点 -->
            <el-form-item :label="$t('user.outlet4')"
                          prop="partTimeFourNetworkOriginalId">
              <el-select v-model="transferForm.partTimeFourNetworkOriginalId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults3"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位4 -->
            <el-form-item :label="$t('user.parttimejob4')"
                          prop="partTimeFourOriginalCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeFourOriginalCode === '' || !transferForm.partTimeFourOriginalCode">
                <div slot="content"
                     v-html="jobCodeContentFour"></div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeFourOriginalCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList3"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <!-- 转岗后 -->
          <el-col :span="6">
            <!-- 兼职4所属网点 -->
            <el-form-item :label="$t('user.outlet4')"
                          prop="partTimeFourNetworkDestinationId">
              <el-select v-model="transferForm.partTimeFourNetworkDestinationId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in transferPartResults3"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位4 -->
            <el-form-item :label="$t('user.parttimejob4')"
                          prop="partTimeFourDestinationCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeFourDestinationCode === '' || !transferForm.partTimeFourDestinationCode">
                <div slot="content">{{transferJobCodeNumFour}}<br />{{transferJobCodeContentFour}}</div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeFourDestinationCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in transferParttimejobList3"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <!-- 兼职5所属网点 -->
            <el-form-item :label="$t('user.outlet5')"
                          prop="partTimeFiveNetworkOriginalId">
              <el-select v-model="transferForm.partTimeFiveNetworkOriginalId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in partResults4"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位5 -->
            <el-form-item :label="$t('user.parttimejob5')"
                          prop="partTimeFiveOriginalCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeFiveOriginalCode === '' || !transferForm.partTimeFiveOriginalCode">
                <div slot="content"
                     v-html="jobCodeContentFive"></div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeFiveOriginalCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in parttimejobList4"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <!-- 转岗后 -->
          <el-col :span="6">
            <!-- 兼职5所属网点 -->
            <el-form-item :label="$t('user.outlet5')"
                          prop="partTimeFiveNetworkDestinationId">
              <el-select v-model="transferForm.partTimeFiveNetworkDestinationId"
                         placeholder=""
                         :disabled="true">
                <el-option v-for="item in transferPartResults4"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 兼职职位5 -->
            <el-form-item :label="$t('user.parttimejob5')"
                          prop="partTimeFiveDestinationCode">
              <el-tooltip class="item"
                          effect="dark"
                          placement="top"
                          :disabled="transferForm.partTimeFiveDestinationCode === '' || !transferForm.partTimeFiveDestinationCode">
                <div slot="content">{{transferJobCodeNumFive}}<br />{{transferJobCodeContentFive}}</div>
                <el-select placeholder=""
                           v-model="transferForm.partTimeFiveDestinationCode"
                           :disabled="true">
                  <el-option v-for="(item,index) in transferParttimejobList4"
                             :key="index"
                             :label="item.positionName"
                             :value="item.positionCode">
                  </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import Vue from 'vue'
import AesUtil from "@/utils/aes_utils";
export default {
  data() {
    return {
      dataForm: {},
      transferForm: {},
      // 宝马集团，合作伙伴，合作院校，经销商集团公司列表
      companyResults: [],
      // 预留经销商
      orgResulets: [],
      // 在职状态
      jobStatus: this.enums['jobStatus'],
      // 审批流程
      registration: this.enums['registration'],
      // 组织类型回显
      orgTypeArr: this.enums['orgType'],
      // 性别
      sexCode: this.enums['sex'],
      // 学历回显
      educationCode: this.enums['educationCode'],
      // 是否同意
      agreePolicy: this.enums['agreePolicy'],
      // 同意登录
      loginFlag: this.enums['loginFlag'],
      // 权限分类
      perClassification: this.enums['perClassification'],
      // 在职状态
      status: this.enums['status'],
      // 品牌
      brandCode: this.enums['brandCode'],
      // 证件类型
      idTypeList: this.enums['idType'],
      // 是否推荐人才库
      recommendFlagArr: this.enums['confirmState'],
      // 是否允许登录
      leafFlag: this.enums['confirmState'],
      // 毕业状态
      graduationStatus: this.enums['graduationStatus'],
      // 是否正式账号
      regulArr: this.enums['confirmState'],
      // 角色
      roleIds: '',
      // 转岗前所属经销商网点，转岗后
      results: [],
      resultsOld: [],
      resultsNew: [],
      // 转岗前主要职位列表
      positionlist: [],
      // 转岗前兼职网点，转岗后
      partResults0: [],
      partResults1: [],
      partResults2: [],
      partResults3: [],
      partResults4: [],
      // 转岗前兼职列表
      parttimejobList0: [],
      parttimejobList1: [],
      parttimejobList2: [],
      parttimejobList3: [],
      parttimejobList4: [],
      // 转岗前主要职位描述code
      jobCodeNum: this.$t('activiti.jobCodeNum'),
      jobCodeContent: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 转岗前兼职职位描述code
      jobCodeNumOne: this.$t('activiti.jobCodeNum'),
      jobCodeNumTwo: this.$t('activiti.jobCodeNum'),
      jobCodeNumThree: this.$t('activiti.jobCodeNum'),
      jobCodeNumFour: this.$t('activiti.jobCodeNum'),
      jobCodeNumFive: this.$t('activiti.jobCodeNum'),
      jobCodeContentOne: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentTwo: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentThree: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFour: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      jobCodeContentFive: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),

      // 转岗后主要职位列表
      transferPositionlist: [],
      // 转岗后兼职网点，转岗后
      transferPartResults0: [],
      transferPartResults1: [],
      transferPartResults2: [],
      transferPartResults3: [],
      transferPartResults4: [],
      // 转岗后兼职列表
      transferParttimejobList0: [],
      transferParttimejobList1: [],
      transferParttimejobList2: [],
      transferParttimejobList3: [],
      transferParttimejobList4: [],
      // 转岗后主要职位描述code
      transferJobCodeNum: this.$t('activiti.jobCodeNum'),
      transferJobCodeContent: this.$t('activiti.jobCodeContent'),
      // 转岗后兼职职位描述code
      transferJobCodeNumOne: this.$t('activiti.jobCodeNum'),
      transferJobCodeNumTwo: this.$t('activiti.jobCodeNum'),
      transferJobCodeNumThree: this.$t('activiti.jobCodeNum'),
      transferJobCodeNumFour: this.$t('activiti.jobCodeNum'),
      transferJobCodeNumFive: this.$t('activiti.jobCodeNum'),
      transferJobCodeContentOne: this.$t('activiti.jobCodeContent'),
      transferJobCodeContentTwo: this.$t('activiti.jobCodeContent'),
      transferJobCodeContentThree: this.$t('activiti.jobCodeContent'),
      transferJobCodeContentFour: this.$t('activiti.jobCodeContent'),
      transferJobCodeContentFive: this.$t('activiti.jobCodeContent'),
      privacyFileUrl: ''
    }
  },
  // 页面初始化
  activated() {
    console.log('activated')
  },
  created() {
    // 接收广播
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_UPCOMING, (data) => {
      this.initialization()
    })
  },
  mounted() {
    this.initialization()
  },
  methods: {
    // 页面初始化
    initialization() {
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs['dataForm'].resetFields()
        }
        if (this.$refs.transferForm) {
          this.$refs['transferForm'].resetFields()
        }
        if (this.$route.query.transferId !== undefined) {
          this.transferForm.transferId = this.$route.query.transferId
          this.getTransferInfo()
        }
      })
    },
    // 获取转岗信息
    getTransferInfo() {
      this.$request.get(`/sys/position/transfer/info/${this.transferForm.transferId}`).then((res, total, code, data) => {
        this.transferForm = {
          ...this.transferForm,
          ...res
        }
        if (res.userId && res.userId !== '') {
          this.dataForm.userId = res.userId
          this.getUserInfo()
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取用户信息
    getUserInfo() {
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(this.dataForm.userId + ''))
      this.$request.get(`/sys/commuser/infomt/${userId}`).then((res, total, code, data) => {
        if (res.birthday && res.birthday !== '') {
          res.birthday = Vue.filter('formatDateNoTime')(res.birthday)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res
        }
        // 拼接隐私协议相对路径
        if (this.dataForm.privacyFileUrl && this.dataForm.privacyFileUrl !== '') {
          this.privacyFileUrl = this.dataForm.uploadHost + this.dataForm.privacyFileUrl
        } else {
          this.privacyFileUrl = ''
        }
        // 赋值网点类型
        this.dataForm.outletType = Vue.filter('coverEnumList')(this.dataForm.networkType, 'networkType', ',')
        // 算岗龄
        let joinDate = Vue.filter('theTime')(this.dataForm.jobcodeJoinDate)
        if (!this.dataForm.jobcodeJoinDate) {
          joinDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
        }
        let now = Date.parse(new Date())
        if (this.dataForm.jobStatus === '20') {
          if (this.dataForm.leaveDate && this.dataForm.leaveDate !== '') {
            now = Vue.filter('theTime')(this.dataForm.leaveDate)
          }
        }
        // 时间差
        let dateDeviation = parseInt(Math.abs(now - joinDate) / 1000 / 60 / 60 / 24, 10)
        this.dataForm.jobcodeAge = dateDeviation
        // 计算宝龄
        let currentVersionDate = 0
        let bmwDateDeviation = 0
        if (this.dataForm.currentVersionDate) {
          currentVersionDate = Vue.filter('theTime')(this.dataForm.currentVersionDate)
          bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
        } else {
          if (this.dataForm.orgJoinDate) {
            currentVersionDate = Vue.filter('theTime')(this.dataForm.orgJoinDate)
            bmwDateDeviation = parseInt(Math.abs(now - currentVersionDate) / 1000 / 60 / 60 / 24, 10)
          }
        }
        this.dataForm.bmwSeniority = bmwDateDeviation + Number(this.dataForm.bmwSeniority)
        this.dataForm.bmwSeniority = (this.dataForm.bmwSeniority / 365).toFixed(2)
        this.dataForm.registrationApprovaStatus = this.dataForm.registrationApprovaStatus + ''
        this.$request.get(`/sys/commuser/sysRoleMT`,
          {
            orgType: this.dataForm.orgType,
            authType: this.dataForm.authType
          }
        ).then((res, total, code, data) => {
          this.rolelist = data.result.map(item => {
            item.roleId = item.roleId + ''
            return item
          })
          let newRolelist = ''
          if (this.dataForm.roleId !== '' && this.dataForm.roleId !== null && this.dataForm.roleId !== undefined) {
            let roleIdList = this.dataForm.roleId.split(',')
            for (let i = 0; i < this.rolelist.length; i++) {
              for (let a = 0; a < roleIdList.length; a++) {
                if (this.rolelist[i].roleId === roleIdList[a]) {
                  newRolelist += this.rolelist[i].roleName + '，'
                }
              }
            }
            newRolelist = newRolelist.substr(0, newRolelist.length - 1)
          }
          this.roleIds = newRolelist
        }).catch((err) => {
          console.log(err)
        })
        if (this.dataForm.orgType === '60') {
          // 转岗前
          if (this.transferForm.partTimeOneOriginalCode && this.transferForm.partTimeOneOriginalCode !== '') {
            // 兼职1网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeOneNetworkOriginalId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults0 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职1职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeOneOriginalCode + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList0 = res
              this.jobCodeNumOne = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentOne = this.jobCodeNumOne + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.transferForm.partTimeTwoOrignialCode && this.transferForm.partTimeTwoOrignialCode !== '') {
            // 兼职2网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeTwoNetworkOriginalId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults1 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职2职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeTwoOrignialCode + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList1 = res
              this.jobCodeNumTwo = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentTwo = this.jobCodeNumTwo + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.transferForm.partTimeThreeOriginalCode && this.transferForm.partTimeThreeOriginalCode !== '') {
            // 兼职3网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeThreeNetworkOriginalId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults2 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职3职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeThreeOriginalCode + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList2 = res
              this.jobCodeNumThree = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentThree = this.jobCodeNumThree + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }if (this.transferForm.partTimeFourOriginalCode && this.transferForm.partTimeFourOriginalCode !== '') {
            // 兼职4网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeFourNetworkOriginalId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults3 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职4职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeFourOriginalCode + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList3 = res
              this.jobCodeNumFour = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentFour = this.jobCodeNumFour + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }if (this.transferForm.partTimeFiveOriginalCode && this.transferForm.partTimeFiveOriginalCode !== '') {
            // 兼职5网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeFiveNetworkOriginalId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.partResults4 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职5职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeFiveOriginalCode + ''
              }
            ).then((res, total, code, data) => {
              this.parttimejobList4 = res
              this.jobCodeNumFive = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContentFive = this.jobCodeNumFive + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          // 转岗后
          if (this.transferForm.partTimeOneDestinationCode && this.transferForm.partTimeOneDestinationCode !== '') {
            // 兼职1网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeOneNetworkDestinationId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.transferPartResults0 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职1职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeOneDestinationCode + ''
              }
            ).then((res, total, code, data) => {
              this.transferParttimejobList0 = res
              this.transferJobCodeNumOne = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.transferJobCodeContentOne = this.$t('activiti.jobCodeContent') + res[0].positionDesc
              } else {
                this.transferJobCodeContentOne = this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.transferForm.partTimeTwoDestinationCode && this.transferForm.partTimeTwoDestinationCode !== '') {
            // 兼职2网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeTwoNetworkDestinationId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.transferPartResults1 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职2职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeTwoDestinationCode + ''
              }
            ).then((res, total, code, data) => {
              this.transferParttimejobList1 = res
              this.transferJobCodeNumTwo = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.transferJobCodeContentTwo = this.$t('activiti.jobCodeContent') + res[0].positionDesc
              } else {
                this.transferJobCodeContentTwo = this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.transferForm.partTimeThreeDestinationCode && this.transferForm.partTimeThreeDestinationCode !== '') {
            // 兼职3网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeThreeNetworkDestinationId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.transferPartResults2 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职3职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeThreeDestinationCode + ''
              }
            ).then((res, total, code, data) => {
              this.transferParttimejobList2 = res
              this.transferJobCodeNumThree = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.transferJobCodeContentThree = this.$t('activiti.jobCodeContent') + res[0].positionDesc
              } else {
                this.transferJobCodeContentThree = this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.transferForm.partTimeFourDestinationCode && this.transferForm.partTimeFourDestinationCode !== '') {
            // 兼职4网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeFourNetworkDestinationId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.transferPartResults3 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职4职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeFourDestinationCode + ''
              }
            ).then((res, total, code, data) => {
              this.transferParttimejobList3 = res
              this.transferJobCodeNumFour = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.transferJobCodeContentFour = this.$t('activiti.jobCodeContent') + res[0].positionDesc
              } else {
                this.transferJobCodeContentFour = this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
          if (this.transferForm.partTimeFiveDestinationCode && this.transferForm.partTimeFiveDestinationCode !== '') {
            // 兼职5网点回显
            this.$request.get('/sys/org/selectOrgByParam',
              {
                orgId: this.transferForm.partTimeFiveNetworkDestinationId,
                orgType: this.dataForm.orgType
              }
            ).then((res, total, code, data) => {
              this.transferPartResults4 = res
            }).catch((err) => {
              console.log(err)
            })
            // 兼职5职位回显
            this.$request.get(`/sys/commuser/selectPositionByCode`,
              {
                positionCode: this.transferForm.partTimeFiveDestinationCode + ''
              }
            ).then((res, total, code, data) => {
              this.transferParttimejobList4 = res
              this.transferJobCodeNumFive = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.transferJobCodeContentFive = this.$t('activiti.jobCodeContent') + res[0].positionDesc
              } else {
                this.transferJobCodeContentFive = this.$t('activiti.jobCodeContent')
              }
            }).catch((err) => {
              console.log(err)
            })
          }
        }
        // 如果有已选预签约，下拉列表只显示当前选项，因为输入下拉的列表默认只显示10个，可能无法正常回显
        if (this.dataForm.dealerShipId && this.dataForm.dealerShipId !== '') {
          this.$request.get(`/sys/org/info/${this.dataForm.dealerShipId}`).then((res, total, code, data) => {
            this.orgResulets = []
            this.orgResulets.push(res)
          }).catch((err) => {
            console.log(err)
          })
        }
        this.$request.get('/sys/org/selectOrgByParam',
          {
            orgId: this.dataForm.orgId,
            orgType: this.dataForm.orgType
          }
        ).then((res, total, code, data) => {
          // 经销商时需要回显品牌
          if (this.dataForm.orgType === '60') {
            var brandCodes = res[0].brandCodes
            this.dataForm.brandCode = Vue.filter('coverEnumList')(brandCodes, 'brandCode', ',')
            this.results = res
          } else {
            this.companyResults = res
          }
        }).catch((err) => {
          console.log(err)
        })
        // 转岗前主要网点
        if (this.transferForm.positionOriginalNetworkId && this.transferForm.positionOriginalNetworkId !== '') {
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.transferForm.positionOriginalNetworkId,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.resultsOld = res
          }).catch((err) => {
            console.log(err)
          })
        }
        // 转岗后主要网点
        if (this.transferForm.positionDestinationNetworkId && this.transferForm.positionDestinationNetworkId !== '') {
          this.$request.get('/sys/org/selectOrgByParam',
            {
              orgId: this.transferForm.positionDestinationNetworkId,
              orgType: this.dataForm.orgType
            }
          ).then((res, total, code, data) => {
            this.resultsNew = res
          }).catch((err) => {
            console.log(err)
          })
        }
        // 根据jobCode回显转岗前主职
        if (this.transferForm.positionOriginalCode && this.transferForm.positionOriginalCode !== '') {
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.transferForm.positionOriginalCode + ''
            }
          ).then((res, total, code, data) => {
            this.positionlist = res
            if (res[0]) {
              this.jobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
              if (res[0].positionDesc) {
                this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + '<br/>' + res[0].positionDesc.replace(/\n/g, "<br/>")
              } else {
                this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
              }
            }
          }).catch((err) => {
            console.log(err)
          })
        }
        // 根据jobCode回显转岗后主职
        if (this.transferForm.positionDestinationCode && this.transferForm.positionDestinationCode !== '') {
          this.$request.get(`/sys/commuser/selectPositionByCode`,
            {
              positionCode: this.transferForm.positionDestinationCode + ''
            }
          ).then((res, total, code, data) => {
            this.transferPositionlist = res
            // TODO i18n控制台报错 Cannot read property '_t' of null 暂时使用文字，原因待调查
            // this.transferJobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
            // if (res[0].positionDesc) {
            //   this.transferJobCodeContent = this.$t('activiti.jobCodeContent') + res[0].positionDesc
            // } else {
            //   this.transferJobCodeContent = this.$t('activiti.jobCodeContent')
            // }
            this.transferJobCodeNum = '职位代码：' + res[0].positionCode
            if (res[0].positionDesc) {
              this.transferJobCodeContent = '职位描述：' + res[0].positionDesc
            } else {
              this.transferJobCodeContent = '职位描述：'
            }
          }).catch((err) => {
            console.log(err)
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
li {
  list-style: none;
}
.img-div {
  text-align: center;
  width: 142px;
  img {
    width: 100%;
    min-height: 100px;
  }
  .modify-img {
    cursor: pointer;
    margin-top: 10px;
  }
}
</style>
